import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import {
  getExportConfigs,
  getExportConfigById,
  createExportConfig,
  updateExportConfig,
  deleteExportConfig,
  GetConfigsParams,
} from "../requests/configs.requests";
import {
  ClassificationExportConfigCreateInput,
  ClassificationExportConfigUpdateInput,
} from "../../types/config";

export const useGetExportConfigs = (params?: GetConfigsParams, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONFIGS, params],
    queryFn: () => getExportConfigs(params),
    enabled,
  });
};

export const useGetExportConfigById = (id: number, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONFIG_DETAIL, id],
    queryFn: () => getExportConfigById(id),
    enabled: enabled && !!id,
  });
};

export const useCreateExportConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: ClassificationExportConfigCreateInput) => createExportConfig(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CONFIGS] });
    },
  });
};

export const useUpdateExportConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: ClassificationExportConfigUpdateInput }) =>
      updateExportConfig(id, input),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CONFIGS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CONFIG_DETAIL, variables.id] });
    },
  });
};

export const useDeleteExportConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteExportConfig(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CONFIGS] });
    },
  });
};
